<div id="gcsaa-feed-item-container" (click)="onSelectItem()">
    <div id="gcsaa-item-title" class="prevent-select">
        {{item?.title}}
    </div>
    <div id="gcsaa-item-date" class="prevent-select">
        -- {{item?.pubDate | date: 'medium'}}
    </div>
</div>
